export const antdThemeValues = Object.freeze({
  primary: '#ee3741',
  secondary: '#23b17c',
  lightBackground: '#fff5fa',
  error: '#ee3741',
  borderLight: '#c1c0c0',
  disabledBackground: '#e1e1e1',
  disabledColor: '#000',
  appBackground: '#f3f2f7',
  white: '#fff',
  borderRadiusBase: 10,
  borderRadiusLarge: 15,
  checkboxBorderRadius: 0,
});
